import { Box, Link, Typography } from '@mui/material'
import ArticleImg1 from 'assets/images/article_img_1.png'
import ArticleImg2 from 'assets/images/article_img_2.png'
import { Text } from 'components'
import { color } from 'config/color'
import type React from 'react'
import { DashboardContainer } from './DashboardContainer'

const ARTICLES = [
  {
    title: 'Energy and Water Conservation Tips',
    image: ArticleImg1,
    link: 'https://residents.nationwideenergypartners.com/conservation-tips'
  },
  {
    title: 'Heat Pumps in Winter Weather',
    image: ArticleImg2,
    link: 'https://residents.nationwideenergypartners.com/heat-pump-video'
  }
]

export const CustomBox: React.FC = () => {
  return (
    <DashboardContainer minHeight="26vh">
      <Box display="flex" flexDirection="column" gap={3}>
        <Text color={color.grey[900]} fontSize="18px" fontWeight="600">
          Quick Tips
        </Text>
        {ARTICLES.map((item, index) => (
          <Box
            key={index}
            bgcolor={color.background[50]}
            display="flex"
            alignItems="center"
            p={2}
            gap={2}
            onClick={() => window.open(item.link, '_blank')}
            sx={{ cursor: 'pointer' }}
          >
            <Box component="img" src={item.image} width={74} height={74} />
            <Box>
              <Typography
                fontWeight="700"
                fontSize="16px"
                color={color.grey[900]}
              >
                {item.title}
              </Typography>
              <Link
                sx={{
                  color: color.primary[700],
                  textDecoration: 'none'
                }}
              >
                Read More
              </Link>
            </Box>
          </Box>
        ))}
      </Box>
    </DashboardContainer>
  )
}
